import React, { useState, useEffect } from "react";
import API from "../Services/ProductType";
import API1 from "../Services/Product";
import API2 from "../Services/Inventory";
import API3 from "../Services/Auth"
import API4 from "../Services/Recipe"
import APISS from '../Services/Location';
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CenterModal from '../Components/CenterModal'
const Receipt = () => {
    const [showTable, setShowTable] = useState(false);
    const [productType, setProductType] = useState([]);
    const [productTypeId, setProductTypeId] = useState("");
    const [product, setProduct] = useState([]);
    const [productId, setProductId] = useState("");
    const [errors, setErrors] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [productList, setProductList] = useState([]);
    const perPage = 10;
    const [measurementUnits, setMeasurementUnits] = useState([]);
    const [rows, setRows] = useState([]);
    const [selectedCenter, setSelectedCenter] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedLocation, setSelectedLocation] = useState("");
    const [location, setLocation] = useState([])

    useEffect(() => {
        // bindProductType();
        bindMeasurementUnit();
        bindLocation();

    }, []);
    const bindLocation = async () => {
        try {
            const response = await APISS.getLocationList({
                is_active: 1,
                limit: 0,
            });
            setLocation(response?.data?.data || []);
            // setLocation1(response?.data?.data || [])
        } catch (error) {
            //setError("Failed to fetch locations.");
            console.error(error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
        }
    };
    const bindMeasurementUnit = async () => {
        try {
            const payload = { is_active: 1 };
            const response = await API3.bindMeasurementUnit(payload);
            setMeasurementUnits(response.data.data.rows);
        } catch (error) {
            if (error.response) {
                if (error.response.status === 403) {
                    window.location.replace("/Login");
                } else if (error.response.status === 404) {
                    console.warn("No record found.");
                    setMeasurementUnits([]);
                } else if (error.response.status === 500) {
                    console.error("Internal Server Error. Please try again later.");
                } else {
                    console.error("Unexpected error:", error.response.status);
                }
            } else {
                console.error("Network error or server not responding:", error);
            }
        }
    };

    const bindProductType = async (location_id) => {
        try {
            const payLoad = {
                //is_active: 1,
                is_inventory: true,
                //is_recipe: 1,
                location_id
            }
            const response = await API4.getProductTypeLocationBy(payLoad);
             const activeData = response?.data?.data?.filter(item => item.is_active === true);
           ///  console.log('activeData',activeData);
            setProductType(activeData || []);
        } catch (error) {
            setErrors((prev) => ({ ...prev, productType: "Failed to fetch Product Type." }));
            console.error(error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
        }
    };

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;

        if (fieldName === "productTypeId") {
            setProductTypeId(value);
        }
        if (fieldName === "productId") {
            setProductId(value);
        }
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }
    };

    const bindProduct = async () => {
        try {
            const paylaod = {
                is_active: 1,
                product_type_id: productTypeId,
                is_recipe: 1,
                limit:0
            }

            const response = await API1.Get_Product(paylaod);
            setProduct(response?.data?.data || []);
        } catch (error) {
            setErrors((prev) => ({ ...prev, product: "Failed to fetch Product." }));
            console.error(error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
        }
    };

    useEffect(() => {
        if (productTypeId) bindProduct();
    }, [productTypeId]);

    const handleSearchClick = async () => {

        if (!productId) {
            toast.error("Please select a product.");
            return;
        }
        handleAddRow(productId, 'up')
        try {
            const response = await API2.bind_Sale_Product_inventory(productId);
            setTotalRecords(response.data.totalCount);
            setProductList(response.data.data);
            //  console.log('rrrrr',response.data.data);
            setShowTable(true);

            window.scrollTo({
                top: document.documentElement.scrollHeight,
                behavior: "smooth",
            });
        }
        catch (error) {

            if (error.response) {
               
                const { status, data } = error.response;
                 // console.log('dddd', error.message,data.message);
                if (status == 403) {
                    window.location.replace("/Login");
                }
                else if (status === 400) {
                    toast.error(data.message || "Bad Request: Please check your input.");
                } else if (status === 404) {
                    toast.error(data.message ||"No inventory found for the selected product.");
                } else if (status === 500) {
                    toast.error("Server error. Please try again later.");
                } else {
                    toast.error("An error occurred. Please try again.");
                }
            } else {

                toast.error("Network error or server is unreachable. Please try again.");
            }

            setProductList([]);
        }
    };
    const handleSelectedCenter = (selectedData) => {
        setSelectedCenter(selectedData);

        if (Array.isArray(selectedData) && selectedData.length > 0) {
            const locationIds = selectedData.join(', ');
            bindProductType(locationIds);
        }
    };
    const totalPages = Math.ceil(totalRecords / perPage);

    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
            handleSearchClick();
        }
    };

    const handleRemoveRow = (index, inventory_product_id) => {
        const updatedRows = rows.filter((_, i) => i !== index);
        setRows(updatedRows);

        const removedProduct = rows.find(row => row.inventory_product_id === inventory_product_id);

        if (removedProduct) {
            setProductList(prevList => [...prevList, {
                id: removedProduct.inventory_product_id,
                name: removedProduct.productName
            }]);
        }
    };
    const handleInputChange = (index, field, value) => {
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, [field]: value } : row
        );
        setRows(updatedRows);
    };

    const handleAddRow = async (id, type) => {
        let newRows = [];
        let duplicateFound = false;

        try {
            if (type === "down") {
                const [filteredProduct] = productList.filter(item => item.id === id);

                if (!filteredProduct) return;

                const idExists1 = rows.some(
                    row => row.inventory_product_id === filteredProduct.id
                );

                if (idExists1) {
                    toast.warning("Product Already Added.");
                    return;
                }

                const unitObj = measurementUnits.find(
                    u => u.id === filteredProduct.unit
                );

                newRows.push({
                    sale_product_id: productId,
                    inventory_product_id: filteredProduct.id,
                    productName: filteredProduct.name,
                    quantity: "",
                    unit: filteredProduct?.unit_id,
                    unitType: unitObj?.type || null,
                    isFetched: filteredProduct.unit_id ? true : false,
                });

                setProductList(prev =>
                    prev.filter(item => item.id !== id)
                );
                toast.success("Product Added Successfully");

            } else {
                setRows([]);

                // console.log('uppppppp se aa raha hai');
                const payload = { sale_product_id: id };
                const response = await API4.getRecipe(payload);

                const details = response?.data?.data;
               // console.log('response', details)
                if (!details || details.length === 0) return;

                for (const item of details) {
                    const idExists = rows.some(
                        row => row.inventory_product_id === item.inventory_product_id
                    );

                    if (idExists) {
                        duplicateFound = true;
                        continue;
                    }
                    const unitObj = measurementUnits.find(
                        u => u.id === item.unit
                    );

                    newRows.push({
                        sale_product_id: item.sale_product_id,
                        inventory_product_id: item.inventory_product_id,
                        productName: item.inventory_name,
                        quantity: item.qty || "",
                        unit: item.unit_id,
                        unitType: unitObj?.type || null,
                        isFetched: true,
                    });
                }
            }

            if (newRows.length > 0) {
                setRows(prevRows => [...prevRows, ...newRows]);
            } else if (duplicateFound) {
                toast.warning("Product already exists");
            }

        } catch (error) {
            console.error("Error adding row:", error);
        }
    };

    const handleSubmit = async () => {
        try {
            for (let row of rows) {
                if (!row.quantity || isNaN(row.quantity) || row.quantity <= 0) {
                    toast.error("Quantity must be a valid number greater than 0.");
                    return;
                }
                if (!row.unit || row.unit == "Select Unit") {
                    toast.error("Please select a unit for each product.");
                    return;
                }
            }
            const payload = {
                data: rows.map(row => ({
                    sale_product_id: productId,
                    inventory_product_id: row.inventory_product_id,
                    qty: row.quantity,
                    unit: row.unit
                }))
            };
        //     console.log('payload',payload);
        //     return;
        //   const response=""
            const response = await API4.Create_Add_Recipe(payload);
            //console.log('response', response.data);
            if (response.status === 200) {
                toast.success(response.data.message);
                setTimeout(() => window.location.reload(), 2000);
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 400) {
                    toast.error(error.response.data.message || "Bad Request. Please check your input.");
                } else {
                    toast.error(`Error: ${error.response.data.message || "Something went wrong!"}`);
                }
            } else {
                toast.error("Network error. Please try again later.");
            }
        }
    };

    const filteredProducts = productList.filter((item) =>
        item.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    const locationOptions = location.map((item) => ({
        value: item.id,
        label: item.name,
    }));

    return (
        <div>
            <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Add Recipe</h4>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-3">
                            
                                <label htmlFor="ddSalesType" className="form-label">
                                    <b>Center</b>
                                </label>

                                <Select
                                    id="ddSalesType"
                                    options={locationOptions}
                                    placeholder="Select Center"
                                    isSearchable={true}
                                    value={locationOptions.find(
                                        (opt) => opt.value === selectedLocation
                                    )}
                                    onChange={(selectedOption) => {
                                        const locationIds = selectedOption?.value;
                                        setSelectedLocation(locationIds);
                                        bindProductType(locationIds);
                                    }}
                                />

                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label htmlFor="ddProductType" className="form-label">Product Type <span style={{ color: "red" }}>*</span></label>
                                    <select
                                        className="form-select"
                                        id="ddProductType"
                                        value={productTypeId}
                                        onChange={(e) => handleFieldChange(e, "productTypeId")}
                                    >
                                        <option value="">Select Product Type</option>
                                        {productType.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>

                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label htmlFor="ddProduct" className="form-label">Product <span style={{ color: "red" }}>*</span></label>
                                    <select
                                        className="form-select"
                                        id="ddProduct"
                                        value={productId}
                                        onChange={(e) => handleFieldChange(e, "productId")}
                                    >
                                        <option value="">Select Product</option>
                                        {product.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>

                                </div>
                            </div>
                            <div className="col-md-3">
                                <label></label>
                                <button className="btn form-control btn-primary mt-4" onClick={handleSearchClick}>
                                    Search
                                </button>
                            </div>
                        </div>

                        <table className="table table-bordered mt-5" style={{ tableLayout: "fixed", width: "100%" }}>
                            <thead>
                                <tr>
                                    <th className="text-center">Action</th>
                                    <th>Product Name</th>
                                    <th>Qty <span style={{ color: "red" }}>*</span></th>
                                    <th>Unit <span style={{ color: "red" }}>*</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row, index) => (
                                    <tr key={index}>
                                        <td className="text-center">
                                            <button
                                                className="btn btn-danger btn-sm"
                                                style={{ backgroundColor: "red" }}
                                                onClick={() =>
                                                    handleRemoveRow(index, row.inventory_product_id)
                                                }
                                            >
                                                <span className="fa fa-trash-o text-white"></span>
                                            </button>
                                        </td>

                                        <td>{row.productName}</td>

                                        <td>
                                            <input
                                                type="number"
                                                min="0"
                                                className="form-control"
                                                placeholder="Enter Quantity"
                                                value={row.quantity}
                                                onChange={(e) =>
                                                    handleInputChange(index, "quantity", e.target.value)
                                                }
                                            />
                                        </td>

                                        <td>
                                            <select
                                                className="form-select"
                                                value={row.unit}
                                                onChange={(e) =>
                                                    handleInputChange(index, "unit", e.target.value)
                                                }
                                                disabled={row.isFetched}
                                            >
                                                <option value="">Select Unit</option>

                                                {measurementUnits
                                                    .filter(
                                                        unit =>
                                                            !row.unitType ||
                                                            unit.type === row.unitType
                                                    )
                                                    .map(unit => (
                                                        <option key={unit.id} value={unit.id}>
                                                            {unit.name}
                                                        </option>
                                                    ))}
                                            </select>
                                        </td>
                                    </tr>
                                ))}

                                <tr>
                                    <td colSpan={4}>
                                        <button
                                            className="btn btn-primary"
                                            onClick={handleSubmit}
                                            disabled={rows.some(
                                                row =>
                                                    !row.quantity ||
                                                    row.quantity <= 0 ||
                                                    !row.unit
                                            )}
                                        >
                                            Submit
                                        </button>
                                    </td>
                                </tr>
                            </tbody>

                            {/* <tbody>
                                {rows.map((row, index) => (

                                    <tr key={index}>
                                        <td>
                                            <button
                                                className="btn btn-danger btn-sm"
                                                onClick={() => handleRemoveRow(index, row.inventory_product_id)}
                                            >
                                                Remove
                                            </button>
                                        </td>
                                        <td>{row.productName}</td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Quantity"
                                                value={row.quantity}
                                                onChange={(e) =>
                                                    handleInputChange(index, "quantity", e.target.value)
                                                }
                                            />
                                        </td>
                                        <td>
                                            <select
                                                className="form-select"
                                                value={row.unit}
                                                onChange={(e) => handleInputChange(index, "unit", e.target.value)}
                                                disabled={row.isFetched} // Disable only if fetched from API
                                            >
                                                <option value="">Select Unit</option>
                                                {measurementUnits.map((unit) => (
                                                    <option key={unit.id} value={unit.id}>
                                                        {unit.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                    </tr>
                                ))}
                                <tr>
                                    <td colSpan={4}>
                                        <button className="btn btn-primary" onClick={handleSubmit}
                                            disabled={rows.some(row => !row.quantity || row.quantity <= 0 || !row.unit)}
                                        >
                                            Submit
                                        </button>
                                    </td>
                                </tr>
                            </tbody> */}
                        </table>
                    </div>
                </div>
            </div>

            {showTable && (
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-6 mb-2">
                                <div className="input-group">
                                    <input type="text" className="form-control" placeholder="Search Product" value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)} />
                                    {/* <button className="btn btn-primary" type="button">Search</button> */}
                                </div>
                            </div>
                        </div>
                        <table className="table table-bordered text-center" style={{ tableLayout: "fixed", width: "100%" }}>
                            <thead>
                                <tr>
                                    <th style={{ width: "100px" }}>SrNo</th>
                                    <th style={{ width: "200px" }}>Action</th>
                                    <th>Product Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredProducts.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{(currentPage - 1) * perPage + index + 1}</td>
                                        <td> <button className="btn btn-sm btn-success"
                                            onClick={() => handleAddRow(item.id, 'down')}
                                        >Add</button></td>
                                        <td>{item.name}</td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {/* <nav aria-label="Page navigation example">
                            <ul className="pagination justify-content-center mt-4">

                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        Previous
                                    </button>
                                </li>

                                {Array.from({ length: totalPages }, (_, index) => (
                                    <li
                                        key={index + 1}
                                        className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(index + 1)}
                                        >
                                            {index + 1}
                                        </button>
                                    </li>
                                ))}

                                <li
                                    className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                >
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                    >
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav> */}
                    </div>
                </div>
            )}
            <ToastContainer />
        </div>
    );
};

export default Receipt;

